(function($){
  var windowWidth = $(window).width();
  var windowHeight = $(window).height();
  var headerheight= null;  
  $(document).on('ready',function(){

    

    //calc height of navoverlay on header alpha
    if($('body').hasClass('navigation_alpha')){
      var heighttop = $("header section.top .container .row").outerHeight(true);
      var height = $(window).height();
      $('header section.left').outerHeight( height - heighttop);
    }

    // navigation toggle button for offcanvas
    let elements = document.querySelectorAll('.offcanvas_toggle_button');
    var offcanvasRight = document.getElementById('offcanvasRight')
    offcanvasRight.addEventListener('show.bs.offcanvas', function () {
      elements.forEach(item => {
        item.classList.add("open");
      })
    })
    offcanvasRight.addEventListener('hide.bs.offcanvas', function () {
      elements.forEach(item => {
        item.classList.remove("open");
      })
    })


    
    //navigation toggle button
    $('.js-toggle-menu, .navoverlay-bodyoverlay').click(function() {
      $('.js-toggle-menu , .navoverlay, .mobilenavoverlay, .navoverlaybackground, .navoverlay-bodyoverlay').toggleClass('is-active');
      $('body').toggleClass('navigation-active');
    });

    //open dropdown op parent click  instead of  open the page 
    $('.navbar-nav.parentnotclickable li.menu-item-has-children>a.nav-link , .navbar-nav.parentclickable li.menu-item-has-children >.dropdown-toggle-div').click(function(){
      console.log("clickevent");
      event.preventDefault();
      $(this).parent().find('>.dropdown-menu').toggleClass('active');
      $(this).parent().find('>.dropdown-toggle').toggleClass('active');
      $(this).parent().find('>.dropdown-menu').toggleClass('show');
      $(this).parent().find('>.dropdown-toggle').toggleClass('show');
    });

    //add dropdown arrow by navigation where there is a subnavigation
    $('.navbar-nav.parentclickable .dropdown-toggle.nav-link').each(function() {
        // Controleer of het volgende sibling-element geen 'dropdown-toggle-div' is
        if (!$(this).next('.dropdown-toggle-div').length) {
            // Als het niet bestaat, voeg dan de nieuwe 'a' tag toe na dit element
            $('<a href="javascript:void(0)" class="dropdown-toggle-div dropdown-toggle"></a>').insertAfter($(this));
        }
    });
  

  
    $('.navbar-nav.parentclickable .dropdown-toggle-div').each(function(){
      $(this).on( 'click', function() {
      $(this).parent().find('>.dropdown-menu').toggleClass('active');
      $(this).parent().find('>.dropdown-toggle').toggleClass('active');
      $(this).parent().find('>.dropdown-menu').toggleClass('show');
      $(this).parent().find('>.dropdown-toggle').toggleClass('show');
      });
    })

    //tootlip header Charlie
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="tooltip"]').tooltip();

    //close subnavigation on click body
    $('body').on('click',function (e) {
      //console.log(e.target);
        if ( (!$(e.target).is('.dropdown-menu *')) && (!$(e.target).is('.dropdown-toggle'))) {
            if ($('.dropdown-menu').hasClass('active')) {
                $('.dropdown-menu' ).removeClass('active');
                $('.dropdown-toggle' ).removeClass('active');
                $('.dropdown-menu' ).removeClass('show');
                $('.dropdown-toggle' ).removeClass('show');
            }
        }
    });

  });

  $(window).on('resize scroll', function() {
    //calc height of wrapper by  header alpha
    if($('body').hasClass('navigation_alpha')){
      var heighttop = $("header section.top .container .row").outerHeight(true);
      var height = $(window).height();
      $('header section.left').outerHeight( height - heighttop);
    }

    //fade small logo in navigation alpha when on scrolling
    if ($(window).scrollTop() >= 300 && windowWidth > 640) {
      $('body.navigation_alpha section.left .logo').addClass('is-active');
    } else {
      $('body.navigation_alpha section.left .logo').removeClass('is-active');
    }

  });
    
  $(window).on('resize ready', function() {
    headerheight = $('header').outerHeight(true);
    windowWidth = $(window).width();
    windowHeight = $(window).height();
    //Choose size of dropdown to place absolute
    $('body.navigation_charlie .nav-bar .nav-item.menu-item-has-children .dropdown-menu li .dropdown-menu').each(function(){
      $(this).parent().on('mouseover',function(){
        var offset1 = offset($(this)[0]);
        if((offset1.left+ $(this).width()+$(this).find('.dropdown-menu').width())>windowWidth){
          $(this).find('.dropdown-menu').addClass('submenu-left');
        }
        else{
          $(this).find('.dropdown-menu').removeClass('submenu-left');
        }
      })
    })
    
  });

  if( $('body').hasClass('navigation_charlie') || $('body').hasClass('navigation_echo') || $('body').hasClass('navigation_foxtrot') ){
    $(window).on('scroll',function(){
      //fixed navigatie on scroll
      if ($(window).scrollTop() >= headerheight*1.2 && windowWidth > 768) {
        $('body').addClass('navigation_notvisible');
        $('body').css('padding-top',headerheight);
        setTimeout(() => {
          $('body').addClass('navigation_fixed');
        }, 30);
      } else {
        $('body').removeClass('navigation_fixed');
        setTimeout(() => {
          $('body').removeClass('navigation_notvisible');
          $('body').css('padding-top',0);
          //$('body').css('transition','padding-top 500ms');
        }, 30);
      }
    });
  }

  if( $('body').hasClass('navigation_alpha') || $('body').hasClass('navigation_bravo') ){
    $(window).on('scroll',function(){
      var s = $(window).scrollTop(),
          d = $(document).height(),
          c = $(window).height();
      var scrollPercent = (s / (d - c)) * 100;
      $('header .progress-bar-wrap .progress-bar').height(scrollPercent+'%');
    });
  }

})(jQuery);

//custom functions (only javascript || No jquery)
	function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}